// extracted by mini-css-extract-plugin
export default {"hashtag":"MessagesParser_hashtag","mention":"MessagesParser_mention","blockCode":"MessagesParser_blockCode","code":"MessagesParser_code","cite":"MessagesParser_cite"};